export default "__VITE_ASSET__CWrOMj_x__"